import { SagaIterator } from 'redux-saga';
import { all, put, take, takeEvery } from 'redux-saga/effects';

import { LOAD_TABLE_META_SUCCESSFUL } from '../../components/Table/constants/actionConstants';
import {
    onboardingInitStartAction,
    onboardingPageReadyForStartAction,
} from '../../modules/onboarding/onboardingActions';
import { ONBOARDING_INIT_SUCCESS } from '../../modules/onboarding/onboardingConstants';
import { EOnboardingPage } from '../../modules/onboarding/types/onboardingTypes';

export function* pagePersonalAccountStartOnboardingSaga() {
    yield put(onboardingInitStartAction({ page: EOnboardingPage.accounts }));
    yield take(ONBOARDING_INIT_SUCCESS);

    yield put(onboardingPageReadyForStartAction());
}

export function* pagePersonalAccountSaga(): SagaIterator {
    yield all([
        takeEvery(LOAD_TABLE_META_SUCCESSFUL, pagePersonalAccountStartOnboardingSaga),
    ]);
}
